<ng-container *ngIf="{
    selectedAttribute: selectedAttribute$ | async,
    addClicked: addClicked$ | async,
} as data">
<emm-management-layout>
    <emm-progress-bar [isLoading$]="anyLoading$"></emm-progress-bar>
    <emm-search-filter
        [addDialog]="true"
        [attr.data-testid]="'attribute_search_bar'"
        [fields]="fields$ | async"
        [isAdminOrAuthor]="this.isAdmin || this.isAuthor"
        [isSuperAdmin]="this.isSuperAdmin"
        [componentName]="'attributes'"
        [displaySearchWithOptions]="false"
        layout-center-header
        (add)="openCreateItemForm()"
        (filter)="onFilter($event)"
    ></emm-search-filter>
    <emm-generic-items-list
        [items]="attributesAsGenericItems$ | async"
        [isReadOnly]="isReadOnly$ | async"
        [contextMenuActions]="attributesContextMenuActions"
        (onSelectItem)="onSelectAttribute($event)"
        layout-center-content
    ></emm-generic-items-list>
    <emm-management-attributes-header
        *ngIf="data.selectedAttribute && !data.addClicked"
        layout-right-header
        [name]="data.selectedAttribute.name"
        [tag]="data.selectedAttribute.tag"
        [type]="data.selectedAttribute.type"
    ></emm-management-attributes-header>
    <emm-management-attributes-form
        *ngIf="!data.addClicked"
        #form
        layout-right-content
        [isSuperAdmin]="isSuperAdmin"
        [isAdmin]="isAdmin"
        (showButtons)="renderButtons($event)"
        (disableButtons)="handleCancel($event)"
    ></emm-management-attributes-form>
    <emm-management-attributes-header
        *ngIf="data.addClicked"
        layout-right-header
        [name]="'New Attribute'"
        [tag]="'TBD'"
        [type]="'TBD'">
    </emm-management-attributes-header>
    <emm-management-attributes-creation-form
        *ngIf="data.addClicked"
        #form
        layout-right-content>
    </emm-management-attributes-creation-form>
    <emm-management-attributes-footer *ngIf="isSuperAdmin && (showButtons | async)"
        [disableCancel]="disableButtons  | async"
        [disableUpdate]="disableButtons  | async"
        layout-right-footer
        (cancel)="cancel()" (submit)="submit()"
    ></emm-management-attributes-footer>
</emm-management-layout>
</ng-container>
